const YOUTUBE_API_URL = `https://youtube.googleapis.com/youtube/v3`;

export class YoutubeApiService {
    static $inject = ['$http'];
    constructor(private $http: ng.IHttpService) {}

    public async getLiveStreamsList(token: string) {
        const response = await fetch(
            `${YOUTUBE_API_URL}/liveStreams?part=snippet%2Ccdn%2CcontentDetails%2Cstatus&mine=true`,
            { headers: { Authorization: `Bearer ${token}` } }
        );

        return response.json();
    }

    public async getLiveBroadcastList(token: string) {
        const response = await fetch(
            `${YOUTUBE_API_URL}/liveBroadcasts?part=snippet%2CcontentDetails%2Cstatus&broadcastType=all&mine=true`,
            { headers: { Authorization: `Bearer ${token}` } }
        );
        return response.json();
    }
}

angular.module('tradersyard').service('YoutubeApiService', YoutubeApiService);
